import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './Loader';
import { isPortalAdmin } from '../utils/portalRoles';

const AdminRoute = ({ children, roles }) => {
  const { token, user, loading } = useAuth();

  const storedToken = localStorage.getItem('token');
  const storedUserStr = localStorage.getItem('user');
  const storedUser = storedUserStr ? JSON.parse(storedUserStr) : null;

  const finalToken = token || storedToken;
  const finalUser = user || storedUser;

  if (loading) {
    return <Loader variant="dark" fullScreen />;
  }

  if (!finalToken || !finalUser) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isPortalAdmin(finalUser.role)) {
    return <Navigate to="/admin/login" replace />;
  }

  if (Array.isArray(roles) && roles.length && !roles.includes(finalUser.role)) {
    const effective = finalUser.role === 'admin' ? 'branchadmin' : finalUser.role;
    if (!roles.includes(effective)) {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  return children;
};

export default AdminRoute;
